import React, {useState, useEffect} from 'react'
import Swal from "sweetalert2";
import { useForm } from 'react-hook-form';

// Material-UI
import { Button, Container, Grid, makeStyles, Paper, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
// Components
import Navbar from "../components/NavbarTitle";
import Background from "../components/BackgroundPattern";
import Footer from '../components/Footer';
//service
import userService from '../services/userService';
import uploadService from '../services/uploadService';

const useStyle = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh"
  },
  paper: {
    margin: theme.spacing(4),
  },
  upload: {
    margin: theme.spacing(4,0),
    padding: theme.spacing(4,4),
    textAlign: "center",
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0),
    },
  },
  submit: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(4,0),
    },
  },
  input: {
    width: "-webkit-fill-available",
    margin: theme.spacing(3,0,1,0),
    padding: theme.spacing(2),
    border: "1px solid rgb(133, 133, 133)",
    borderRadius: "5px"
  },
  title: {
    color: theme.palette.black.main,
    fontWeight: "bold"
  }
}))

const CardInformasi = ( {classes} ) => {
  return (
    <section id="card-informasi" style={{marginBottom: "50px"}}>
      <Paper elevation={3} className={classes.paper}>
        <Grid container>
          <Grid item xs={12} >
            <Alert severity="info" variant="filled">
              <AlertTitle>
                {"INFORMASI"}
              </AlertTitle>
              <Typography variant="body2" gutterBottom>
                {"1. Berkas pendaftaran terdiri dari : "}
                <strong>{"Formulir Pendaftaran, Surat Izin Orang Tua dan Surat Komitmen"}</strong>
              </Typography>
              <Typography variant="body2" gutterBottom>
                {"2. Pastikan semua Berkas pendaftaran "}
                <strong>{"sudah ditanda tangani"}</strong>
              </Typography>
              <Typography variant="body2" gutterBottom>
                {"3. "}
                <strong>{"Scan atau Foto"}</strong>
                {" semua Berkas Pendaftaran harus "}
                <strong>{"terlihat jelas dan terbaca"}</strong>
              </Typography>
              <Typography variant="body2" gutterBottom>
                {"4. Unggah hasil scan semua Berkas Pendaftaran "}
                <strong>{"(maksimal 1MB/surat)"}</strong>
              </Typography>
              <Typography variant="body2" gutterBottom>
                {"5. Apabila ukuran file melebihi 1MB, "}
                <strong>silahkan dikompres terlebih dahulu <a rel="noopener noreferrer" target="_blank" href="https://compressjpeg.com/" >disini</a></strong>
              </Typography>
            </Alert>
          </Grid>
        </Grid>
      </Paper>
    </section>
  )
}

const UnggahBerkas = ( {classes} ) => {
  const { register, handleSubmit } = useForm();
  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append('file_form_pendaftaran', data.formulirPendaftaran[0]);
    formData.append('file_komitmen', data.suratKomitmen[0]);
    formData.append('file_persetujuan', data.suratIzinOrangTua[0]);

    uploadService.berkas(formData)
    .then ((response) => {
      return (
        Swal.fire({
          icon: "success",
          title: "Berkas Berhasil Dikirim!",
          text: "Silahkan Tunggu Konfirmasi dari Panitia",
        }), window.location.reload()
      )
    })
    .catch((err) => {
      console.log(err.response)
      return (
        Swal.fire({
          icon: "error",
          title: "Kirim Berkas Gagal!",
          text: err.response.data ? err.response.data.meta.message : "Hubungi kami melalui WhatsApp",
        })
      );
    })
  }

  return (
    <section id="unggah-berkas">
      <Paper elevation={5} className={classes.paper}>
        <Container>
          <form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
            <Grid container spacing={4}>
              <Grid item xs={12} sm={12} md={4}>
                <Paper elevation={5} className={classes.upload}>
                  <Typography variant="h5" className={classes.title}>
                    {"Formulir Pendaftaran"}
                  </Typography>
                    <input
                      className={classes.input}
                      id="formulirPendaftaran"
                      name="formulirPendaftaran"
                      type="file"
                      accept="image/png, image,jpeg, application/pdf"
                      ref={register({required: true})}
                    />
                </Paper>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Paper elevation={5} className={classes.upload}>
                  <Typography variant="h5" className={classes.title}>
                    {"Surat Izin Orang Tua"}
                  </Typography>
                    <input
                      className={classes.input}
                      id="suratIzinOrangTua"
                      name="suratIzinOrangTua"
                      type="file"
                      accept="image/png, image,jpeg, application/pdf"
                      ref={register({required: true})}
                    />
                </Paper>
              </Grid>
              <Grid item xs={12} sm={12} md={4}>
                <Paper elevation={5} className={classes.upload}>
                  <Typography variant="h5" className={classes.title}>
                      {"Surat Komitmen"}
                  </Typography>
                    <input
                      className={classes.input}
                      id="suratKomitmen"
                      name="suratKomitmen"
                      type="file"
                      accept="image/png, image,jpeg, application/pdf"
                      ref={register({required: true})}
                    />
                </Paper>
              </Grid>    
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={12} md={12}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  type="submit"
                  className={classes.submit}
                  fullWidth
                >
                  {"Kirim Berkas Pendaftaran"}
                </Button>
                </Grid>
            </Grid>
          </form>
        </Container>
      </Paper>
    </section>
  )
}

const InfoTunggu = ({classes}) => {
  return (
    <section id="info-tunggu">
      <Grid container className={classes.content}>
        <Grid item xs={12}>
          <Alert variant="filled" severity="warning" className={classes.info} elevation={3}>
            <AlertTitle style={{paddingTop: 5}}>
              {"BERKAS SEDANG DI VALIDASI"}
            </AlertTitle>
            <Typography variant="body2">
              {"Mohon tunggu, berkas sedang di validasi oleh Panitia PCAB KSR PMI Unit UNJ."}
            </Typography>
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <Alert variant="filled" severity="info" className={classes.info} elevation={3}>
            <AlertTitle style={{paddingTop: 5}}>
              {"NARAHUBUNG"}
            </AlertTitle>
            <Typography variant="body2">
              {"Untuk Informasi lebih lanjut, dapat menghubungi Panitia PCAB KSR PMI Unit UNJ melalui WhatsApp dengan nomor +62857-8031-7112."}
            </Typography>
          </Alert>
        </Grid>
      </Grid>
    </section>
  )
}

const CardInfo = ({ classes }) => {
  let savedTahapInfo = localStorage.getItem('tahap');
  const [showTahapUser, setTahapUser] = useState(savedTahapInfo);

  useEffect(() => {
    userService.getUserInfo()
    .then((response) => {
      setTahapUser(response.data.tahap);
      localStorage.setItem('tahap', response.data.tahap);
    })
    .catch(e => {
      console.log(e)
      return (
        window.location.reload()
      )
    })
  }, [setTahapUser]);

  switch(showTahapUser) {
    case "3":
      return(
        <div>
          <CardInformasi classes={classes}/>
          <UnggahBerkas classes={classes}/>
        </div>
      )
    default:
      return (
        <InfoTunggu classes={classes}/>
      )
  }
}

const ValidasiBerkas = () => {
  const classes = useStyle()
  return (
    <section id="validasi-berkas" className={classes.container}>
      <Background/>
      <Navbar title="VALIDASI BERKAS PENDAFTARAN" />
        <Container style={{flex: "1"}}>
          <CardInfo classes={classes} />
        </Container>
      <Footer/>
    </section>
  )
}

export default ValidasiBerkas
